<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Loading Spinner</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Loading-->
                <div class="loading-container">
                    <div class="loading">
                        <img src="/static/images/loading.gif">
                    </div>
                </div>
                <!--Loading-->
                <div class="cards-container">
                    <div class="title">Card with Image</div>
                    <div class="col-4">
                        <div class="cards-block">
                            <b-card title="Card with Image"
                                    img-src="http://localhost:8080/static/images/cardsimg.jpg"
                                    img-alt="Image"
                                    img-top
                                    tag="article"
                                    style="max-width: 20rem;"
                                    class="mb-2">
                                <p class="card-text">
                                    Some quick example text to build on the card title and make up the bulk of the card's content.
                                </p>
                                <b-button href="#" variant="primary">Read More</b-button>
                            </b-card>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="cards-block">
                            <b-card title="Card with Image"
                                    img-src="http://localhost:8080/static/images/cardsimg.jpg"
                                    img-alt="Image"
                                    img-top
                                    tag="article"
                                    style="max-width: 20rem;"
                                    class="mb-2">
                                <p class="card-text">
                                    Some quick example text to build on the card title and make up the bulk of the card's content.
                                </p>
                                <b-button href="#" variant="primary">Read More</b-button>
                            </b-card>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="cards-block">
                            <b-card title="Card with Image"
                                    img-src="http://localhost:8080/static/images/cardsimg.jpg"
                                    img-alt="Image"
                                    img-top
                                    tag="article"
                                    style="max-width: 20rem;"
                                    class="mb-2">
                                <p class="card-text">
                                    Some quick example text to build on the card title and make up the bulk of the card's content.
                                </p>
                                <b-button href="#" variant="primary">Read More</b-button>
                            </b-card>
                        </div>
                    </div>

                </div>




            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    import { Card } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {
                dismissSecs: 10,
                dismissCountDown: 0,
                showDismissibleAlert: false
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/loading-spinner.vue